export default __webpack_public_path__ + "static/media/not-found.344ee7f1.png";